export const STRING = {
  DOT: ".",
  EMPTY: "",
  COMMA: ",",
  SPACE: " ",
  SLASH: "/",
  QUOTE: "'",
  QUESTION: "?",
  DOUBLE_QUOTES: "\"",
  FILE: {
    JSON: ".json",
  },
} as const;
